module.exports = __webpack_public_path__ + "img/user-1.cf49517b.png";